<template>
  <div>
    <!-- <total-result-header ym_from="单车对比-搜索叶子节点" :data="data"/> -->
    <div class="white_bg">
        <div class="analyse_item">
            <h2>基础项得分：<strong>{{ data.base_score}}分</strong></h2>
            <div class="search_leaf_node">
               <input type="text" v-model="search_val" placeholder="输入评测项，例：速度、安全" @keyup.enter="inputFn">
                <div class="search_leaf_button" @click="searchFn"></div>
            </div>
        </div>
        <div class="search_result">
            <el-table
                empty-text="没有匹配的相关项目节点"
                border
                v-loading="loading"
                :data="search_result_data"
                row-key="node_id"
                :style="{
                    width: '100%',
                }"
            >
                 <el-table-column
                    :resizable="false"
                    label="评测项"
                    :show-overflow-tooltip="true"
                >
                    <template #default="scope">
                        <div class="node_name">
                            {{scope.row.name}}
                        </div>
                        <div class="path_names flex">
                            (
                            <template v-for="(item,ind) in scope.row.path_node" :key="ind">
                                <span class="path_name_layer" v-if="ind>0">></span>
                                <span class="path_name">{{item.node_name}}</span>
                            </template>
                            )
                        </div>
                        <div>
                            
                        </div>
                    </template>
                 </el-table-column>

                 <el-table-column
                    :resizable="false"
                    label="得分"
                    width=330
                >
                    <template #default="scope">
                         <tree-table-item
                    :data="{
                      type: 2,
                      score: scope.row.score,
                      total_score: scope.row.total_score,
                    }"
                  ></tree-table-item>
                    </template>
                 </el-table-column>

                <el-table-column
                    :resizable="false"
                    label="详情"
                    width="200"
                    class-name="td_class"
                >
                    <template #default="scope">
                    <span
                        class="detail_tag"
                        @click="getDetail(scope.row);
                        showRuleDesc=false;"
                    >
                        详情
                        <div class="cur_node_has_img" v-if="scope.row.has_img>0"></div>
                        <div class="cur_node_has_video" v-if="scope.row.has_video>0"></div>
                    </span>
                    </template>
                </el-table-column>

            </el-table>
        </div>
    </div>
     <el-drawer
      v-model="dialogVisible"
      :title="node_name"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="my_dialog" v-if="dialogVisible">
        <table class="detail_table" border="1">
          <tr class="detail_title">
            <td class="detail_attr">车型</td>
            <template v-for="(item, ind) in [{model_name:data.brand+' '+data.model_name}]" :key="ind">
              <td class="detail_title_item" colspan="1">
                {{ item.model_name }}
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>得分</div>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div class="attr_box">
                  <div class="attr_node_score">
                    <span class="attr_node_score_num"
                      >{{
                        (item["1"] && item["1"].item_value_val) || 0
                      }}分</span
                    >
                  </div>
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == true">
            <td class="detail_attr">标准 <span v-if="detail_list.length > 1" id="triangle-up" @click="showRuleDesc=false"></span> </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <!-- 背景色占位 -->
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == false">
            <td class="detail_attr">
              标准
              <span id="triangle-down" @click="showRuleDesc = true"></span>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  "
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">主观评价</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['2'] && item['2'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">图片素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item['4'] && item['4'].ext_info.length > 0">
                  <div class="detail_val_pic">
                    <div
                      class="detail_pic_left"
                      @click.stop="
                        previewImg(item['4'] && item['4'].ext_info, 'img')
                      "
                    >
                      <div class="detail_pic_left_img">
                        <img
                          :src="item['4'].ext_info[0].attach_value || ''"
                          alt="图片加载失败"
                        />
                        <span class="more_pic">{{
                          item["4"] && item["4"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看图片</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['4'] && item['4'].item_value_val"
                      v-html="item['4'] && item['4'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item['4'] && item['4'].ext_info,data.model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及图片素材
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">视频素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div
                      class="detail_video_left"
                      @click.stop="
                        previewImg(item['5'] && item['5'].ext_info, 'video')
                      "
                    >
                      <div class="detail_pic_left_video">
                        <video controlsList="nodownload" :src="item['5'].ext_info[0].attach_value"></video>
                        <span class="more_pic">{{
                          item["5"] && item["5"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['5'] && item['5'].item_value_val"
                      v-html="item['5'] && item['5'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item['5'] && item['5'].ext_info,data.model_name,node_name)"></div>
                </template>

                <div class="no_img" v-else>
                  当前测试子节点本次未涉及视频素材
                </div>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </el-drawer>
    <div class="my_swiper_dialog" v-if="swiperVisible">
      <div class="my_swiper_dialog_content">
        <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
        <swiper :list="preview_list" :type="preview_type" />
      </div>
    </div>
  </div>
</template>

<script>
// import TotalResultHeader from "@/components/contrast/single/TotalResult.vue";
import {
    ElTable,
    ElTableColumn,
    ElDrawer,
    ElMessage
} from "element-plus";
import TreeTableItem from "@/components/common/views/treeTable/TreeTableItem.vue";
import Swiper from "@/components/swiper/Swiper.vue";
import { getCarSummaryDataV2 ,searchNodeV2,getTestDetailV2 } from "@/api";
import { ref } from "vue";
import { useRoute } from "vue-router";
import store from "@/store";
export default {
    name:"search",
    components:{
        // TotalResultHeader,
        ElTable,
        ElTableColumn,
        TreeTableItem,
        ElDrawer,
        Swiper
    },
    setup(){
        const route = useRoute();
        let { model_id , keywords } = route.query;
        console.log(model_id,keywords)
        const search_val = ref(keywords);
        const data = ref({});
        const _getData = ()=>{
            getCarSummaryDataV2({
                model_id,
                get_base:1
            }).then(res=>{
                const callData = res.data;
                callData.stars_per = Number(res.data.stars_per);
                if (callData.performance_score_detail) {
                    callData.performance_score = 0;
                }
                data.value = callData;
            })
        }
        _getData();
        const loading = ref(false);
        const search_result_data =ref([]);
        const searchFn = ()=>{
            search_result_data.value = [];
            loading.value = true;
            searchNodeV2({
                model_id:model_id,
                keyword:search_val.value
            }).then(res=>{
                console.log(res);
                search_result_data.value = res.data;
                loading.value = false;
            })
        }
        searchFn();

        //获取详情数据
        const node_name = ref("");
        const detail_list = ref([]);
        const dialogVisible = ref(false);
        const getDetail = (row) => {
            console.log(row)
        node_name.value = row.node_name || row.name;
        let node_id = row.node_id || row.id;
    
        let promise_list2 = [{
            report_id:data.value.report_id,
            model_id:data.value.model_id,
            node_id: node_id,
        }].map((item) => {
            return new Promise((resolve, reject) => {
            getTestDetailV2({
                report_id: item.report_id,
                model_id: item.model_id,
                node_id: node_id,
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
            });
        });
        Promise.all(promise_list2).then((res_list) => {
            detail_list.value = res_list.map((res) => {
            let item_value = {};
            if (res.data && res.data.item_value) {
                res.data.item_value.forEach((item) => {
                item_value[item.item_value_val_type] = item;
                });
                item_value["9"] = res.data["node_desc"];
            }
            return item_value;
            });
            console.log(detail_list.value);
            dialogVisible.value = true;
        });
        };

        const swiperVisible = ref(false);
        const preview_list = ref([]);
        const preview_type = ref("img");
        const previewImg = (list, type) => {
        preview_list.value = list;
        preview_type.value = type;
        swiperVisible.value = true;
        };
        const closeSwiperDialog = () => {
        document.querySelectorAll("video").forEach((item) => {
            item.pause();
        });
        swiperVisible.value = false;
        };
        const showRuleDesc = ref(false);
        const inputFn = ()=>{
          searchFn();
        }

        const downloadFn = (list,model_name,node_name)=>{
          store.addDownload(list,model_name,node_name);
          ElMessage.success("已添加到下载队列中")
        }
        return {
            data,
            search_val,
            searchFn,
            search_result_data,
            loading,
            inputFn,

            getDetail,
            detail_list,
            dialogVisible,

            previewImg,
            preview_list,
            preview_type,
            swiperVisible,
            closeSwiperDialog,

            showRuleDesc,

            downloadFn,
            store
        }
    }
}
</script>

<style lang="less" scoped>
.white_bg {
    width: 1200px;
    padding: 37px 48px;
}
.analyse_item {
  position: relative;
  margin-bottom: 30px;
  h2 {
    position: relative;
    padding-left: 31px;
    font-size: 18px;
    color: #404248;
    font-weight: bold;
    margin-bottom: 33px;
    line-height: 20px;
    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: "";
      width: 5px;
      height: 20px;
      background-color: #4ed6f7;
      border-radius: 2px;
    }
    strong {
      margin-left: 8px;
      color: #e7816e;
    }
  }
  .search_leaf_node{
    width: 220px;
    height: 33px;
    background-position: 179px center;
    border-radius: 2px;
    position: absolute;
    top:0;
    right: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d7d7d7;
    input{
      width: 100%;
      height: 100%;
      appearance: none;
      outline: none;
      border: none;
      background: transparent;
      padding: 0 10px;
      font-size: 12px;
      &::placeholder{
        color: #bebebe;
      }
    }
    &:has(input:focus){
      border: 1px solid #1FBCBF;
    }
    .search_leaf_button{
      width: 50px;
      height: 100%;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png) no-repeat center center;
      background-size: 17px 17px;
      cursor: pointer;
    }
  }

}
.search_result{
    :deep(.el-table){
        min-height: 400px;
    }
    .node_name{
        padding: 0 10px;
        font-size: 16px;
        color: #555;
        font-weight: 900;
    }
    .path_names{
        padding: 0 10px;
        font-size: 12px;
        align-items: center;
        .path_name_layer{
            margin: 0 2px;
            color: #bbb;
        }
    }
 
    .detail_tag{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: #709ae8;
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 0;
        padding-left: 70px;
        .cur_node_has_img{
            width: 19px;
            height: 16px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/83321666601504_.jpg) no-repeat center center;
            background-size: 100%;
            margin-left: 10px;
        }
        .cur_node_has_video{
            width: 19px;
            height: 20px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/83331666601504_.jpg) no-repeat center center;
            background-size: 100%;
            margin-left: 10px;
        }
    }
}

:deep(.el-dialog) {
  width: auto;
  height: auto;
  max-width: 99vw;
  max-height: 99vh;
  margin: 0;
}

:deep(.modal_transparent) {
  background: transparent;
}

:deep(.el-drawer__body) {
  overflow-y: auto;
}
:deep(.el-progress-bar__innerText) {
  color: #000;
}

.detail_val_text {
  padding: 16px 17px;
  white-space: pre-line;
}
.no_img {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #777c89;
}
.detail_val_pic {
  display: flex;
  align-items: center;
  .detail_pic_left {
    width: 73px;
    height: 80px;
    cursor: pointer;
    .detail_pic_left_img {
      width: 73px;
      height: 60px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .detail_pic_right {
    font-size: 12px;
    font-weight: bold;
    color: #777c89;
    line-height: 16px;
  }
}
.detail_val_video {
  display: flex;
  align-items: center;
  .detail_video_left {
    width: 92px;
    height: 84px;
    cursor: pointer;
    .detail_pic_left_video {
      width: 92px;
      height: 64px;
      position: relative;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
.look_pic {
  width: 100%;
  height: 16px;
  font-size: 12px;
  color: #5287ea;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my_dialog {
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  // box-shadow: 11px 10px 26px 3px rgba(74, 97, 150, 0.16);
  max-width: 90vw;
  height: calc(100vh - 75px);
  overflow-x: auto;
  overflow-y: auto;
  // position: fixed;
  // top:50%;
  // left: 50%;
  // transform: translate(-50%,-50%);
  z-index: 99;
}

.my_swiper_dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .my_swiper_dialog_content {
    width: auto;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .my_swiper_dialog_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: absolute;
      top: 40px;
      right: 40px;
      cursor: pointer;
      z-index: 2;
    }
  }
}

#triangle-up {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid;
}
#triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid;
}
</style>